import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {MenuService} from '../../shared/menu.service';

@Injectable()
export class ConfigurationConnectivityResolverService implements Resolve<void> {

    constructor(private readonly menuService: MenuService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        this.menuService.disableMenu();
        this.menuService.disableTree();
    }
}
